import { render, staticRenderFns } from "./AddFeedbackModal.vue?vue&type=template&id=4ebce9ec&scoped=true&"
import script from "./AddFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./AddFeedbackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebce9ec",
  null
  
)

export default component.exports